import React from "react"
import { DateTime } from "luxon"

class DateTimePickerDays extends React.Component {

  render() {
    let footer = this.renderFooter()
    let date = this.props.viewDate
    let locale = date.locale
    let tableChildren = ([
        <thead key="th">
          <tr key="h">
            <th key="p" className="rdtPrev" onClick={this.props.subtractTime(1, 'months')}><span>‹</span></th>
            <th key="s" className="rdtSwitch" onClick={this.props.showView('months')} colSpan={5} data-value={this.props.viewDate.month}>{date.toFormat('LLLL') + ' ' + date.year}</th>
            <th key="n" className="rdtNext" onClick={this.props.addTime(1, 'months')}><span>›</span></th>
          </tr>
          <tr key="d">{this.getDaysOfWeek(locale).map(function (day, index) { return <th key={day + index} className="dow">{day}</th>})}</tr>
        </thead>,  
        <tbody key="tb">{this.renderDays(locale)}</tbody>
    ])
    if (footer) {
      tableChildren.push(footer)
    }
    return <div className="rdtDays"><table>{tableChildren}</table></div>
  }

  getDaysOfWeek(locale) {
    let day = DateTime.local().setLocale(locale).startOf('week')
    if (locale == 'en') {
      day = day.minus({day: 1})
    }
    let days = []
    for (let i = 0; i<7; i++) {
      days[i] = day.toFormat('ccc')
      day = day.plus({ days: 1 })
    }
    return days
  }

  renderDays(locale) {
    let self = this
    let date = this.props.viewDate
    let selected = this.props.selectedDate && this.props.selectedDate
    let prevMonth = date.minus({months: 1})
    let currentYear = date.year
    let currentMonth = date.month
    let weeks = []
    let days = []
    // Go to the last week of the previous month
    prevMonth = prevMonth.set({day: prevMonth.daysInMonth}).startOf('week')
    if (locale == 'en') {
      prevMonth = prevMonth.minus({day: 1})
    }
    let lastDay = prevMonth.plus({days: 42})
    while (prevMonth < lastDay) {
      let classes = 'rdtDay'
      let currentDate = prevMonth
      if ((prevMonth.year === currentYear && prevMonth.month < currentMonth) || (prevMonth.year < currentYear))
        classes += ' rdtOld'
      else if ((prevMonth.year === currentYear && prevMonth.month > currentMonth) || (prevMonth.year > currentYear))
        classes += ' rdtNew'
      if (selected && prevMonth.hasSame(selected, 'day'))
        classes += ' rdtActive'
      if (prevMonth.hasSame(DateTime.local(), 'day'))
        classes += ' rdtToday'
      let isDisabled = !self.props.isValidDay(currentDate, selected)
      if (isDisabled)
        classes += ' rdtDisabled'
      let dayProps = {
        key: prevMonth.toFormat('M_d'),
        'data-value': prevMonth.day,
        className: classes
      }
      if (!isDisabled) {
        dayProps.onClick = this.updateSelectedDate
      }
      days.push(this.renderDay(dayProps, currentDate))
      if (days.length === 7) {
        weeks.push(<tr key={prevMonth.toFormat('M_d')}>{days}</tr>)
        days = []
      }
      prevMonth = prevMonth.plus({days: 1})
    }
    return weeks
  }

  updateSelectedDate = (event) => {
    this.props.updateSelectedDate(event, true)
  }

  renderDay(props, currentDate) {
    return <td {...props}>{currentDate.day}</td>
  }

  renderFooter() {
    if (!this.props.timeFormat) {
      return ''
    }
    var date = this.props.selectedDate || this.props.viewDate
    return (
      <tfoot key="tf">
        <tr>
          <td onClick={this.props.showView('time')} colSpan={7} className="rdtTimeToggle">{date.toFormat(this.props.timeFormat)}</td>
        </tr>
      </tfoot>
    )
  }

}

export default DateTimePickerDays